var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49967 10.0835H16.4997C16.7428 10.0835 16.9759 10.1801 17.1479 10.352C17.3198 10.5239 17.4163 10.757 17.4163 11.0002C17.4163 11.2433 17.3198 11.4764 17.1479 11.6483C16.9759 11.8203 16.7428 11.9168 16.4997 11.9168H5.49967C5.25656 11.9168 5.0234 11.8203 4.85149 11.6483C4.67958 11.4764 4.58301 11.2433 4.58301 11.0002C4.58301 10.757 4.67958 10.5239 4.85149 10.352C5.0234 10.1801 5.25656 10.0835 5.49967 10.0835V10.0835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.8eaa413132330800f35425c112019c87.svg";
export { ForwardRef as ReactComponent };